import endSearchSession from 'mini-mail-search-store/lib/actions/endSearchSession';
import setStaticFolderScopeId from 'mini-mail-search-store/lib/actions/setStaticFolderScopeId';
import startSearchSession from 'mini-mail-search-store/lib/actions/startSearchSession';
import { lazyStartSearch } from 'mini-mail-search-actions';
import { logUsage } from 'owa-analytics';

/**
 * Set the folder scope and trigger a new search for keyword with new session
 * As the session ends off focus from search input element, we need to create a session for folder scope change
 * @param folderId item the user selected from folder scope context menu
 */
const setStaticFolderScopeIdUtil = async (folderId: string): Promise<void> => {
    // Datapoint to log only when user triggers change in search folder scope
    logUsage('SearchFolderScopeChanged', null, { isCore: true });
    setStaticFolderScopeId(folderId);
    startSearchSession();
    lazyStartSearch.importAndExecute();
    endSearchSession();
};

export default setStaticFolderScopeIdUtil;
